/* blend cross-sell add-to-cart + drawer refresh.
   Event-delegated, binds once, survives Dawn's #CartDrawer re-renders. */
(function () {
  if (window.__blendCart) return;
  window.__blendCart = true;

  var inflight = false;

  function refreshDrawer() {
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') +
      '?sections=cart-drawer,cart-icon-bubble';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var parser = new DOMParser();

        if (data['cart-drawer']) {
          var drawerDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
          var newDrawer = drawerDoc.querySelector('#CartDrawer');
          var liveDrawer = document.querySelector('#CartDrawer');
          if (newDrawer && liveDrawer) {
            liveDrawer.innerHTML = newDrawer.innerHTML;
            var hostEl = document.querySelector('cart-drawer');
            if (hostEl) hostEl.classList.remove('is-empty');
            // innerHTML replacement throws away the overlay's click-to-close listener
            // (bound once in the CartDrawer constructor). Re-bind it so the dimmed-area
            // tap — the primary mobile dismiss — keeps working after a cross-sell add.
            var overlay = liveDrawer.querySelector('#CartDrawer-Overlay');
            if (overlay && hostEl && typeof hostEl.close === 'function') {
              overlay.addEventListener('click', function () { hostEl.close(); });
            }
          }
        }

        if (data['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
          var liveBubble = document.querySelector('#cart-icon-bubble');
          if (newBubble && liveBubble) liveBubble.innerHTML = newBubble.innerHTML;
        }
      });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-blend-add]');
    if (!btn) return;
    evt.preventDefault();
    if (inflight) return;

    var variantId = btn.getAttribute('data-blend-add');
    if (!variantId) return;

    inflight = true;
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        return refreshDrawer();
      })
      .then(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function (err) {
        console.warn('[blend-cart] add to cart failed', err);
        btn.disabled = false;
        btn.classList.remove('is-loading');
      })
      .finally(function () {
        inflight = false;
      });
  });
})();
